// Code review - In Progress
// Documentation - In Progress
import React, { useEffect, useRef } from 'react';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';

// const TextEditor = ({ value = '', onChange, onBlur, name, error, disabled }) => {
//   const editorRef = useRef(null);
//   const quillRef = useRef(null);

//   useEffect(() => {
//     if (!editorRef.current || quillRef.current) return;

//     quillRef.current = new Quill(editorRef.current, {
//       theme: 'snow',
//       modules: {
//         toolbar: [
//           ['bold', 'italic', 'underline'],
//           [{ list: 'ordered' }, { list: 'bullet' }],
//           ['link'],
//           [{ color: [] }, { background: [] }],
//           ['clean'],
//         ],
//       },
//     });

//     // Set initial content
//     if (value) {
//       quillRef.current.root.innerHTML = value;
//     }

//     // On text change
//     quillRef.current.on('text-change', () => {
//       const content = quillRef.current.root.innerHTML;
//       if (onChange) onChange(content);
//     });

//     // On blur
//     quillRef.current.root.addEventListener('blur', () => {
//       const content = quillRef.current.root.innerHTML;
//       if (onBlur) onBlur({ target: { name, value: content } });
//     });
//   }, []);

//   // Sync with external value updates
//   useEffect(() => {
//     if (quillRef.current && value !== quillRef.current.root.innerHTML) {
//       quillRef.current.root.innerHTML = value;
//     }
//   }, [value]);

//   // Disable editor when the `disabled` prop is true
//   useEffect(() => {
//     if (quillRef.current) {
//       const editor = quillRef.current;
//       if (disabled) {
//         editor.setText(editor.getText()); // Prevent changes
//         editor.disable(); // Disable editing
//       } else {
//         editor.enable(); // Enable editing
//       }
//     }
//   }, [disabled]);

//   return (
//     <div className="w-full">
//       <div ref={editorRef} style={{ height: '100px' }} className="border rounded" />
//       {error && <p className="text-red-500 text-sm font-medium mt-1">{error}</p>}
//     </div>
//   );
// };


const TextEditor = ({
  value = '',
  onChange,
  onBlur,
  name,
  error,
  disabled,
  height = 100, // default height in pixels
}) => {
  const editorRef = useRef(null);
  const quillRef = useRef(null);

  useEffect(() => {
    if (!editorRef.current || quillRef.current) return;

    quillRef.current = new Quill(editorRef.current, {
      theme: 'snow',
      modules: {
        toolbar: [
          ['bold', 'italic', 'underline'],
          [{ list: 'ordered' }, { list: 'bullet' }],
          ['link'],
          [{ color: [] }, { background: [] }],
          ['clean'],
        ],
      },
    });

    if (value) {
      quillRef.current.root.innerHTML = value;
    }

    quillRef.current.on('text-change', () => {
      const content = quillRef.current.root.innerHTML;
      if (onChange) onChange(content);
    });

    quillRef.current.root.addEventListener('blur', () => {
      const content = quillRef.current.root.innerHTML;
      if (onBlur) onBlur({ target: { name, value: content } });
    });
  }, []);

  useEffect(() => {
    if (quillRef.current && value !== quillRef.current.root.innerHTML) {
      quillRef.current.root.innerHTML = value;
    }
  }, [value]);

  useEffect(() => {
    if (quillRef.current) {
      const editor = quillRef.current;
      if (disabled) {
        editor.setText(editor.getText());
        editor.disable();
      } else {
        editor.enable();
      }
    }
  }, [disabled]);

  return (
    <div className="w-full">
      <div
        ref={editorRef}
        style={{ height: `${height}px` }} // dynamically apply height
        className="border rounded"
      />
      {error && <p className="text-red-500 text-sm font-medium mt-1">{error}</p>}
    </div>
  );
};


export default TextEditor;
